module.exports = {
  DY_DYNAMIC_API: '//cdn.dynamicyield.com/api/{DY_ID}/api_dynamic.js',
  DY_STATIC_API: '//cdn.dynamicyield.com/api/{DY_ID}/api_static.js',
  TYPEAHEAD: 'https://www.falabella.com/s/typeahead/v3/{value}?source=web&country={region}',
};
